import { AutoComplete, ISelectType, SwitchInput, useFormContext } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { TTicketServiceForm } from "../TicketServiceSchema";

const translationPath = "chatBot.page.register.ticketService.";

/** Código do tipo de serviço de tickets "Whatsapp" */
export const WHATSAPP_TICKET_SERVICE_TYPE_CODE = "1";

interface IExternalChatFieldsProps {
  options: ISelectType[];
}

export const ExternalChatFields = memo(
  ({ options }: IExternalChatFieldsProps) => {
    const { t } = useTranslation();
    const { control, setValue, getValues } =
      useFormContext<TTicketServiceForm>();

    const ticketServiceType = useWatch({ name: "ticketServiceType", control });
    const externalChatSiteApp = useWatch({
      name: "externalChatSiteApp",
      control,
    });

    const isWhatsapp =
      ticketServiceType?.code === WHATSAPP_TICKET_SERVICE_TYPE_CODE;
    const hasExternalChatSiteApp = isWhatsapp && !!externalChatSiteApp;

    // Limpa os valores dos campos ocultos para não enviá-los ao backend
    useEffect(() => {
      if (!isWhatsapp && getValues("externalChatSiteApp")) {
        setValue("externalChatSiteApp", null, { shouldDirty: true });
      }
    }, [isWhatsapp, getValues, setValue]);

    useEffect(() => {
      if (hasExternalChatSiteApp) return;
      if (getValues("fullScreenMode")) {
        setValue("fullScreenMode", false, { shouldDirty: true });
      }
      if (getValues("sendProtocolNumber")) {
        setValue("sendProtocolNumber", false, { shouldDirty: true });
      }
    }, [hasExternalChatSiteApp, getValues, setValue]);

    if (!isWhatsapp) return null;

    return (
      <>
        <Grid item xs={12} sm={6}>
          <AutoComplete
            options={options}
            getOptionLabel={(option) => {
              return option.name;
            }}
            size="small"
            label={
              t(translationPath + "external_chat_site_app") ||
              "Site / Aplicação para Chat Interno (4uChat)"
            }
            name="externalChatSiteApp"
          />
        </Grid>

        {hasExternalChatSiteApp && (
          <>
            <Grid item xs={12} sm={6} display="flex" alignItems="center">
              <SwitchInput
                name="fullScreenMode"
                label={
                  t(translationPath + "full_screen_mode") || "Modo Tela Cheia"
                }
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <SwitchInput
                name="sendProtocolNumber"
                label={
                  t(translationPath + "send_protocol_number") ||
                  "Enviar o Protocolo ao finalizar o ticket quando transferir para o chat interno (4uChat)"
                }
              />
            </Grid>
          </>
        )}
      </>
    );
  },
);
